export { default as main } from './main/main-states';
export { default as login } from './login/login-states';
export { default as registration } from './registration/registration-states';
export { default as personalData } from './personal_data/personal-data-states';
export { default as authorization } from './authorization/authorization-states';
export { default as creditRating } from './credit_rating/credit-rating-states';
export { default as documents } from './documents/documents-states';
